import { useEffect } from "react";

// Warn before leaving/closing the tab when there are unsaved changes.
// (Route-level blocking needs a data router; this covers tab close/reload and
// pairs with an in-page UnsavedBar for save/discard.)
export function useUnsavedChanges(dirty) {
  useEffect(() => {
    if (!dirty) return;
    const handler = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty]);
}
